import { Link } from "react-router-dom";
import { CircleLoader } from "react-spinners";
import { Controller } from "react-hook-form";
import { useState } from "react";
import Card from "../../card";
import Input from "../../input";
import Button from "../../button";
import { Control, FieldValues } from "react-hook-form";
import Icon from "../../../assets/icons";

interface LoginProps {
  handleLogin: (e: React.FormEvent<HTMLFormElement>) => void;
  control: Control<FieldValues>;
  loading: boolean;
}

const Login = ({ handleLogin, control, loading }: LoginProps) => {
  const [viewPassword, setViewPassword] = useState(false);
  const rememberMeJSON = localStorage.getItem("rememberMe");
  const rememberMe = rememberMeJSON ? JSON.parse(rememberMeJSON) : null;
  const [rememberMeClicked, setRememberMeClicked] = useState(
    rememberMe ? true : false
  );

  const handleShowPassword = () => {
    setViewPassword((previousValue): boolean => !previousValue);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <Card title="Welcome Back!" subtitle="Sign in to access your account">
      <form className="mt-6 md:mt-8" onSubmit={handleLogin}>
        <div className="flex flex-col gap-4 md:gap-6 mb-5">
          <div>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Enter a valid email. E.g, example@gmail.com",
                },
              }}
              render={({ field, fieldState }) => (
                <Input
                  value={field.value}
                  placeholder="name@example.com"
                  className="w-full "
                  label="Email"
                  icon="emailIcon"
                  error={fieldState?.error?.message}
                  onChange={field.onChange}
                />
              )}
            />
          </div>

          <div className="w-full">
            <Controller
              name="password"
              control={control}
              rules={{
                required: "Password is required",
              }}
              render={({ field, fieldState }) => (
                <div className="w-full relative">
                  <Input
                    label="Password"
                    type={viewPassword ? "text" : "password"}
                    value={field.value}
                    className="w-full"
                    onChange={field.onChange}
                    icon="passwordIcon"
                  />
                  <button
                    onClick={handleShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    className="w-5 h-5 absolute top-1/2 right-2 transform -translate-y-1/2 mt-4"
                    type="button"
                  >
                    <Icon
                      name={!viewPassword ? "eyecloseicon" : "eyeopenicon"}
                    />
                  </button>
                  {fieldState?.error && (
                    <p className="absolute bottom-[-18px] left-0 text-red-500 text-xs">
                      {fieldState.error.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
        </div>

        <div className="flex justify-between items-center">
          {/* <div className="flex flex-row gap-1 md:gap-3 items-center">
            <Controller
              name="rememberMe"
              control={control}
              defaultValue={rememberMe ? true : false}
              render={({ field }) => (
                <input
                  type="checkbox"
                  id="rememberMe"
                  className="w-5 h-5 md:h-8 md:w-8 text-green-500 border-2 border-green-500 rounded focus:outline-none focus:border-green-700 cursor-pointer"
                  checked={rememberMeClicked}
                  onClick={() => setRememberMeClicked(!rememberMeClicked)}
                  {...field}
                />
              )}
            />
            <label className="text-sm md:text-base">Remember me</label>
          </div> */}

          <button className="text-[#047401] hover:text-[#35D081] font-normal text-sm ml-auto ">
            <Link to="/forgot-password">Forgot password?</Link>
          </button>
        </div>

        <div className="flex justify-center items-center mt-5">
          <Button
            size="lg"
            variant="primary"
            type="submit"
            className="font-normal"
          >
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={20} />
            ) : (
              <div className="flex gap-3">
                Sign in <Icon name="signIcon" />
              </div>
            )}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default Login;
